export default __webpack_public_path__ + "static/media/3.037ecff0.jpg";